import styled from 'styled-components';
import { Buckets } from '../../constants';

export const HomeWrapper = styled.div`
  margin: 0 auto;
  max-width: 1800px;
  background: #f4f8fa;
`;

export const HomeContentWrapper = styled.div`
  margin: 0 auto;
  max-width: 1800px;
  width: auto;
  display: flex;
  flex-direction: column;
  background: #fff;
`;

export const GarageWrapper = styled.div<{
  addVehicleExpValue: any;
}>`
  background: white;
  border: 0;
  ${(props) =>
    props.addVehicleExpValue !== Buckets.CONTROL &&
    `border-bottom-right-radius: 3rem;`};
`;

export const GarageInnerWrapper = styled.div`
  background: white;
  width: 100%;
  flex-shrink: 0;
`;

export const HomeBodyWrapper = styled.div`
  background: #f4f8fa;
`;

export const OneCarGarageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  background: #f4f8fa;
`;
